import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";

import useAuth from "../../hooks/useAuth";

export type PrivateRouteProps = RouteProps & {
  fallback?: string;
};

/**
 * The user must be authenticated to access a private route.
 */
function PrivateRoute(props: PrivateRouteProps) {
  const { fallback = "/login", ...routeProps } = props;
  const { authenticationService, loggedIn } = useAuth();
  const { keepSessionOpen } = authenticationService.getUserCredentials();

  return (
    <>
      {loggedIn || keepSessionOpen === "1" ? (
        <Route {...routeProps} />
      ) : (
        <Redirect to={fallback} />
      )}
    </>
  );
}

export default PrivateRoute;
